import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { Router } from '@angular/router';
import { AppComponent } from 'app/app.component';
import { SsAuthService } from 'shared/services/SS-Auth/ss-auth.service';
import { UserService } from 'shared/services/User/user.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  user: any;
  userForm: FormGroup;
  isSame: boolean;

  constructor(
    private router: Router,
    private app: AppComponent,
    private apiService: SsAuthService,
    private alertService: AlertPopupService,
    private userService: UserService
    ) { }

  ngOnInit() {
    this.user = this.userService.user;
    this.userForm = new FormGroup({
      email: new FormControl({ value: this.user.email, disabled: true }),
      firstName: new FormControl({ value: this.user.firstName, disabled: true }),
      lastName: new FormControl({ value: this.user.lastName, disabled: true }),
      number: new FormControl({ value: 'Phone Number', disabled: true }),
      newPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
      confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    });
  }

  checkSame() {
    if (this.userForm.get('newPassword').value !== '' && this.userForm.get('confirmPassword').value !== ''
      && this.userForm.get('newPassword').value === this.userForm.get('confirmPassword').value) {
      this.isSame = true;
    }
  }

  imageChange() {
    console.log('image change fjunction call');
  }

  saveChanges() {
    this.app.toggleLoadingMsg('loading');
    this.apiService.saveNewPassword(this.userForm.get('newPassword').value, this.user.uid).subscribe(result => {
      this.alertService.errorAlertSuccess('Boom! Your password has been reset.');
      this.app.dismissLoading();
    }, err => {
      this.app.dismissLoading();
      this.alertService.errorAlert('There was an error resetting your password.' +
        'Please click the link in your email again or request another link. ');
    });
  }

  home() {
    this.router.navigateByUrl('/groups');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/user-profile/user-profile.component.ts